import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../../../assets/img/icons/eye.svg'
import _imports_1 from '../../../assets/img/icons/left-arrow-purple.svg'
import _imports_2 from '../../../assets/img/icons/right-arrow-purple.svg'


const _hoisted_1 = { class: "card border-0 shadow-none rounded-1 mb-25" }
const _hoisted_2 = { class: "card-body p-xl-40" }
const _hoisted_3 = { class: "table-responsive style-three" }
const _hoisted_4 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_5 = { class: "shadow-none text-black" }
const _hoisted_6 = { class: "shadow-none text-black" }
const _hoisted_7 = { class: "shadow-none text-black" }
const _hoisted_8 = { class: "shadow-none text-black" }
const _hoisted_9 = { class: "shadow-none text-black" }
const _hoisted_10 = { class: "shadow-none" }
const _hoisted_11 = { class: "shadow-none text-end pe-0" }
const _hoisted_12 = { class: "button-group d-flex flex-wrap align-items-center" }
const _hoisted_13 = { class: "row pb-45 align-items-center" }
const _hoisted_14 = { class: "col-sm-6" }
const _hoisted_15 = { class: "d-flex align-items-center page-unit" }
const _hoisted_16 = { class: "col-sm-6 text-sm-end text-center" }
const _hoisted_17 = { class: "page-nav list-style" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 pt-0"
                }, "DATE"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 pt-0"
                }, "SELLER"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 pt-0"
                }, "CUSTOMER"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 pt-0"
                }, "STATUS"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 pt-0"
                }, "TOTAL AMOUNT"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 pt-0"
                }, "PAYMENT TYPE"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 pt-0 pe-0"
                }, "ACTION")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sales, (sale) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: sale.id
                }, [
                  _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.formatDateHT(sale.transactionDate)), 1),
                  _createElementVNode("td", _hoisted_6, _toDisplayString(sale.sellerFullName), 1),
                  _createElementVNode("td", _hoisted_7, _toDisplayString(sale.paymentCustomerName || 'N/A'), 1),
                  _createElementVNode("td", _hoisted_8, [
                    _createElementVNode("button", {
                      class: _normalizeClass(sale.status || 'PendingDelivery')
                    }, _toDisplayString(sale.status || 'N/A'), 3)
                  ]),
                  _createElementVNode("td", _hoisted_9, " HTG " + _toDisplayString(sale.totalAmount ? sale.totalAmount.toFixed(2) : '0.00'), 1),
                  _createElementVNode("td", _hoisted_10, [
                    _createElementVNode("button", {
                      class: _normalizeClass(sale.paymentType)
                    }, _toDisplayString(sale.paymentType || 'N/A'), 3)
                  ]),
                  _createElementVNode("td", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_router_link, {
                        to: { name: 'SaleDetailsPage', params: { id: sale.id} },
                        title: "View",
                        class: "me-2"
                      }, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: "Image"
                          }, null, -1)
                        ])),
                        _: 2,
                        __: [4]
                      }, 1032, ["to"])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "fs-13" }, "Showing sales per page", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pageSize) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changePageSize && _ctx.changePageSize(...args))),
            class: "text-title border-0 fs-14 bg-transparent"
          }, _cache[6] || (_cache[6] = [
            _createElementVNode("option", { value: "10" }, "10", -1),
            _createElementVNode("option", { value: "20" }, "20", -1),
            _createElementVNode("option", { value: "30" }, "30", -1)
          ]), 544), [
            [_vModelSelect, _ctx.pageSize]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("ul", _hoisted_17, [
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.previousPage && _ctx.previousPage(...args))),
              disabled: _ctx.currentPage === 1
            }, _cache[8] || (_cache[8] = [
              _createElementVNode("img", {
                src: _imports_1,
                alt: "Previous"
              }, null, -1)
            ]), 8, _hoisted_18)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visiblePages, (page) => {
            return (_openBlock(), _createElementBlock("li", { key: page }, [
              _createElementVNode("a", {
                onClick: ($event: any) => (_ctx.goToPage(page)),
                class: _normalizeClass({ active: page === _ctx.currentPage })
              }, _toDisplayString(page), 11, _hoisted_19)
            ]))
          }), 128)),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
              disabled: _ctx.currentPage === _ctx.totalPages
            }, _cache[9] || (_cache[9] = [
              _createElementVNode("img", {
                src: _imports_2,
                alt: "Next"
              }, null, -1)
            ]), 8, _hoisted_20)
          ])
        ])
      ])
    ])
  ], 64))
}